<template lang="pug">
#nav
  .centered-content
    router-link.logo-link(:to="'/'")
      img#logo(alt="budgee logo" src="@/assets/budgee-logo.svg" )
    .header-links
      router-link.header-link(
        v-for="link in menuLinks" 
        :key="link.name" 
        :to="link.link") {{link.name}}
    .right-controls
      bw-waitlist

  
      //- a.bw-button.push-button(href="https://freebusy.io/r.j.w.cross@gmail.com/budgee-introduction") 
        span Book a time
      //a.bw-button-outlined(href="https://live.budg.ee") 
        span Free Trial  
      //a.bw-button.push-button(href="https://live.budg.ee") 
        span Login
      //- .icon-button
      //-   .fas.fa-bars(@click="menuOpen= !menuOpen")
      //- .mobile-menu.elevation-4(v-if="menuOpen")
      //-   .close-menu-gaurd(@click="menuOpen= false")
      //-   router-link.header-link(
      //-     v-for="link in menuLinks"
      //-     :key="link.name"
      //-     :to="link.link"
      //-     @click.native="menuOpen= false"
      //-     ) {{link.name}}
</template>

<script>
import BwWaitlist from "@/components/shared/BwWaitlist";
export default {
  data: function() {
    return {
      menuOpen: false,
      menuLinks: [
        //{ name: "Features", link: "/features" },
        //{ name: "Pricing", link: "/pricing" },
        //{ name: "About", link: "/about" },
        //{ name: "Resources", link: "/resources" },
        // { name: "Contact", link: "/contact" }
      ]
    };
  },
  components: { BwWaitlist }
};
</script>

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl"
#nav
  width: 100%
  position: fixed
  top: 0
  z-index: 5 !important
  height: var(--header-height)
  background: var(--header-background)
  border-bottom: 1px solid #ccc
#logo
  width: 200px
  margin-left: -21px
  padding-right: 4px
  padding-left: 4px


a.bw-button
  margin: 0
.right-controls
  display: flex
  flex-direction: row
  align-items: center
  height: 100%
  padding-left: 12px
.centered-content
  flex-direction: row
  justify-content: flex-end
  display: flex
  align-items: center
  height: 100%
.header-links
  height: fit-content
.header-link
  text-decoration: none
  padding: 15px
  font-weight: bold
  color: rgba(0,0,0,0.68)
  height: fit-content
  transition: 0.1s
  &:hover
    color: var(--primary)

//.release-tag
//   position: absolute
//   top: 64px
//   left: calc(var(--page-gutter) + 141px)
//   padding: 2px 8px
//   border-radius: 10px
//   background: #1cbbb5
//   color: white
//   font-weight: bold
//  font-size: 13px
.mobile-menu
  width: 200px
  background: white
  top: 35px
  position: absolute
  right: 40px
  border-radius: 3px
  display: flex
  flex-direction: column
  .header-link
    transition: 0.2s
    z-index: 2
    &:hover
      background: #ccedeb
.fa-bars
  font-size: 26px
  color: rgba(0,0,0,0.77)
  cursor: pointer
  margin-left: 20px
  &:hover
    color: rgba(0,0,0,0.57)
.header-links
  display: block
.icon-button, .mobile-width
  display: none
.logo-link
  margin-right: auto
@media mq-tablet-wide
  #nav
    width: 100vw
  .header-links
    display: none
  .icon-button
    display: block
  ::v-deep .d-flex
    display: none
  .close-menu-gaurd
    z-index: 1
    position: fixed
    top: 0
    bottom: 0
    left: 0
    right: 0
    width: 100%
    height: 100%
@media mq-tablet
  #logo
    width: 130px
  .release-tag
    top: 57px
    left: 105px
    font-size: 8px
  .centered-content
    padding: 0 calc(var(--page-gutter) / 2)
  .normal-width
    display: none
  .mobile-width
    display: inline
  .push-button
    padding: 10px 10px
    font-size: 13px
  .fa-bars
    margin-left: 8px
</style>
